import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type OrderStatus =
  | "completed"
  | "canceled"
  | "pending"
  | "processing"
  | "dispute_open";

export type OrderForm = PaginationParameters<{
  date_end?: number;
  date_start?: number;
  device_id?: string;
  max_sum?: number;
  min_sum?: number;
  status?: OrderStatus;
  order_id?: string;
}>;

export type RequisiteOrdersForm = PaginationParameters;

export type Order = {
  created_at: string;
  created_at_unix: number;
  device_name: string;
  ern: number;
  ern_usdt: number;
  id: string;
  merchant_amount?: number;
  merchant_amount_usdt?: number;
  message?: string;
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_start_amount: number;
  order_start_amount_usdt: number;
  // price_history?: PriceHistory[];
  requisite: string;
  // requisite_name: string;
  status: OrderStatus;
  exchange_rate: number;
};

export type OrderResponse = PaginationResponse<{ user_order: Order[] }>;

export type RequisiteOrder = {
  created_at: string;
  created_at_unix: number;
  device_name: string;
  ern: number;
  ern_usdt: number;
  exchange_rate: number;
  id: string;
  merchant_amount: number;
  merchant_amount_usdt: number;
  message: string;
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_start_amount: number;
  order_start_amount_usdt: number;
  requisite: string;
  status: string;
};

export type RequisiteOrdersResponse = PaginationResponse<{
  orders: Order[];
  total_count: number;
}>;

export const getOrders = async (userId: string, data: OrderForm) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<OrderResponse>({
      url: `api/v1/users/orders/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("Orders failed:", error);
    throw error;
  }
};

export const getRequisiteOrders = async (
  requisiteId: string,
  data: RequisiteOrdersForm
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<RequisiteOrdersResponse>({
      url: `api/v1/requisites/orders/${requisiteId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("Requisite orders failed:", error);
    throw error;
  }
};

export const confirmOrder = async (userId: string, orderId: string) => {
  try {
    const response = await fetchData<string>({
      method: "POST",
      url: `api/v1/users/${userId}/order/${orderId}`,
    });

    return response;
  } catch (error) {
    console.error("Confirm order failed:", error);
    throw error;
  }
};
